module.exports = __webpack_public_path__ + "static/zorast@2x-8973bcb9a8826aeeffc04e5d6b75965e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/pricing/zorast@2x.jpg
// module id = 936
// module chunks = 18116671869107 235176306749093